import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchPayrollComponent } from './search-payroll/search-payroll.component';

@Component({
  selector: 'app-search',
  standalone: true,
  imports: [ NgbNavModule, SearchPayrollComponent],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchComponent implements OnInit {
  public titulo = 'listado'
  public tab = 'ingreso'

  constructor() { }

  ngOnInit(): void {
  }

}
